<template>
  <div
    v-if="healthdata"
    class="container"
  >
    <div
      v-if="! hasBreakdownInformation"
      class="row"
    >
      <div class="col-12 col-md-8 mb-4">
        <div class="card flex-grow-1">
          <div class="card-body text-center">
            For a complete "Picture of Your Health", take our <router-link :to="{ name: 'health-data', query: { type: 'full' } }">FULL Health Assessment</router-link>!
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-8 mb-4">
        <div class="card flex-grow-1">
          <div class="card-header text-center">
            <h4>Your Health Scorecard</h4>
          </div>
          <div class="card-body">
            <linear-gauge
              v-if="hasBreakdownInformation"
              title="Favorable Fitness Factor®"
              :value="healthdata.scorecard.favorable_fitness_factor"
              :show-labels="true"
            />
            <hr v-if="hasBreakdownInformation">
            <h5 class="text-center">
              Individual Factor®
            </h5>
            <div class="text-center">
              <div class="text-center individual-factor__wrapper">
                <span class="individual-factor__value">{{ healthdata.scorecard.individual_factor }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="card flex-grow-1">
          <div class="card-header text-center">
            <h4>Your current FOOD SPIRAL®: {{ healthdata.scorecard.food_spiral.name }}</h4>
          </div>
          <div class="card-body">
            <img
              class="card-image-top w-100 mb-2"
              data-toggle="modal"
              data-target="#foodSpiralModal"
              :src="healthdata.scorecard.food_spiral.image.path_thumb"
              :alt="healthdata.scorecard.food_spiral.name + ' FOOD SPIRAL®'"
            >
            <div
              id="foodSpiralModal"
              class="modal fade"
              tabindex="-1"
              role="dialog"
              aria-labelledby="foodSpiralModalLabel"
              aria-hidden="true"
            >
              <div
                class="modal-dialog modal-dialog-centered modal-lg"
                role="document"
              >
                <div class="modal-content">
                  <div class="modal-header">
                    <h5
                      id="foodSpiralModalLabel"
                      class="modal-title"
                    >
                      {{ healthdata.scorecard.food_spiral.name }} FOOD SPIRAL®
                    </h5>
                    <button
                      type="button"
                      class="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">×</span>
                    </button>
                  </div>
                  <div class="modal-body">
                    <img
                      class="w-100"
                      :src="healthdata.scorecard.food_spiral.image.path_full"
                      :alt="healthdata.scorecard.food_spiral.name + ' FOOD SPIRAL®'"
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="card-content text-center" />
          </div>
        </div>

        <div class="card flex-grow-1" v-if="hasBreakdownInformation">
          <div class="card-header text-center">
            <h4>Your Score Breakdown</h4>
          </div>
          <ul class="list-group ">
            <li class="list-group-item d-flex flex-column align-items-center">
              <linear-gauge
                title="Eating Habits"
                :display-val="healthdata.scorecard.factor_groups.eating.points"
                :value="healthdata.scorecard.factor_groups.eating.percentage"
              />
              <router-link
                v-if="can('access-scorecard-details')"
                :to="{name: 'scorecard.eating'}"
                class="text-white btn btn-success"
              >
                View Details
              </router-link>
              <button
                v-else
                v-tooltip:top="'Requires Premium Plan'"
                class="text-white btn btn-success disabled"
              >
                View Details
              </button>
            </li>
            <li class="list-group-item d-flex flex-column align-items-center">
              <linear-gauge
                title="Exercise Habits"
                :display-val="healthdata.scorecard.factor_groups.exercise.points"
                :value="healthdata.scorecard.factor_groups.exercise.percentage"
              />
              <router-link
                v-if="can('access-scorecard-details')"
                :to="{name: 'scorecard.exercise'}"
                class="text-white btn btn-success"
              >
                View Details
              </router-link>
              <button
                v-else
                v-tooltip:top="'Requires Premium Plan'"
                class="text-white btn btn-success disabled"
              >
                View Details
              </button>
            </li>
            <li class="list-group-item d-flex flex-column align-items-center">
              <linear-gauge
                title="Medical"
                :display-val="healthdata.scorecard.factor_groups.medical.points"
                :value="healthdata.scorecard.factor_groups.medical.percentage"
              />
              <router-link
                v-if="can('access-scorecard-details')"
                :to="{name: 'scorecard.medical'}"
                class="text-white btn btn-success"
              >
                View Details
              </router-link>
              <button
                v-else
                v-tooltip:top="'Requires Premium Plan'"
                class="text-white btn btn-success disabled"
              >
                View Details
              </button>
            </li>
            <li class="list-group-item d-flex flex-column align-items-center">
              <linear-gauge
                title="Lifestyle"
                :display-val="healthdata.scorecard.factor_groups.lifestyle.points"
                :value="healthdata.scorecard.factor_groups.lifestyle.percentage"
              />
              <router-link
                v-if="can('access-scorecard-details')"
                :to="{name: 'scorecard.lifestyle'}"
                class="text-white btn btn-success"
              >
                View Details
              </router-link>
              <button
                v-else
                v-tooltip:top="'Requires Premium Plan'"
                class="text-white btn btn-success disabled"
              >
                View Details
              </button>
            </li>
          </ul>
        </div>

        <div class="card flex-grow-1">
          <div class="card-header text-center">
            <h4>General Information</h4>
          </div>
          <ul class="list-group ">
            <li
              v-if="healthdata.scorecard.age"
              class="list-group-item d-flex justify-content-between align-items-center"
            >
              Age: <span class="font-bold">{{ healthdata.scorecard.age }}</span>
            </li>
            <li class="list-group-item d-flex justify-content-between align-items-center">
              Height: <span class="font-bold">{{ healthdata.answers.general.measurements.height.feet }}' {{ healthdata.answers.general.measurements.height.inches }}"</span>
            </li>
            <li class="list-group-item d-flex justify-content-between align-items-center">
              Weight:
              <span class="font-bold">
                {{ healthdata.answers.general.measurements.weight }} lbs.
              </span>
            </li>
            <li
              v-if="healthdata.answers.general.measurements.waist"
              class="list-group-item d-flex justify-content-between align-items-center"
            >
              Waist:
              <span class="font-bold">
                {{ healthdata.answers.general.measurements.waist }}"
              </span>
            </li>
            <li
              v-if="healthdata.answers.general.measurements.hips"
              class="list-group-item d-flex justify-content-between align-items-center"
            >
              Hips:
              <span class="font-bold">
                {{ healthdata.answers.general.measurements.hips }}"
              </span>
            </li>
            <li class="list-group-item d-flex flex-column">
              <div class="d-flex justify-content-between">
                <span class="align-self-start">BMI:</span>
                <span class="align-self-end">{{ healthdata.scorecard.bmi }}</span>
              </div>
              <h5 class="align-self-center p-3">
                <i>{{ bmiStatus(healthdata.scorecard.bmi) }}</i>
              </h5>
              <dial-gauge
                :min="0"
                :max="60"
                :value="healthdata.scorecard.bmi"
                :display-value-header="false"
                :options="bmiGaugeOpts"
              />
            </li>
            <li
              v-if="healthdata.answers.general.measurements.pulse"
              class="list-group-item d-flex flex-column"
            >
              <div class="d-flex justify-content-between">
                <span class="font-bold">Pulse: </span>
                <span>{{ healthdata.answers.general.measurements.pulse }}bpm</span>
              </div>
              <h5 class="align-self-center p-3">
                <i>{{ pulseStatus(healthdata.answers.general.measurements.pulse) }}</i>
              </h5>
              <dial-gauge
                :min="0"
                :max="160"
                :display-value-header="false"
                :options="pulseGaugeOpts"
                :value="healthdata.answers.general.measurements.pulse"
              />
            </li>

            <li
              v-if="healthdata.answers.general.measurements.bodyfat"
              class="list-group-item d-flex flex-column"
            >
              <div class="d-flex justify-content-between">
                <span class="font-bold">Body Fat: </span>
                <span>
                  {{ healthdata.answers.general.measurements.bodyfat }}%</span>
              </div>
              <h5 class="align-self-center p-3">
                <i>{{ bodyFatStatus(gender(),healthdata.answers.general.measurements.bodyfat) }}</i>
              </h5>
              <dial-gauge
                v-show="gender() === 'male'"
                :min="0"
                :max="40"
                :options="bodyFatGaugeOpts_male"
                :value="healthdata.answers.general.measurements.bodyfat"
              />
              <dial-gauge
                v-show="gender() === 'female'"
                :min="0"
                :max="40"
                :options="bodyFatGaugeOpts_female"
                :value="healthdata.answers.general.measurements.bodyfat"
              />
            </li>
            <li
              v-if="healthdata.answers.medical.labs.general.blood_pressure.systolic && healthdata.answers.medical.labs.general.blood_pressure.diastolic"
              class="list-group-item d-flex justify-content-between align-items-center"
            >
              <span class="font-bold">Blood Pressure: </span>
              <span
                v-if="healthdata.answers.medical.labs.general.blood_pressure.systolic < 90 || healthdata.answers.medical.labs.general.blood_pressure.diastolic < 60"
                class="text-yellow-dark"
              >Low ({{ healthdata.answers.medical.labs.general.blood_pressure.systolic }}/{{ healthdata.answers.medical.labs.general.blood_pressure.diastolic }})</span>
              <span
                v-else-if="healthdata.answers.medical.labs.general.blood_pressure.systolic <= 120 && healthdata.answers.medical.labs.general.blood_pressure.diastolic <= 80"
                class="text-green-light"
              >Normal ({{ healthdata.answers.medical.labs.general.blood_pressure.systolic }}/{{ healthdata.answers.medical.labs.general.blood_pressure.diastolic }})</span>
              <span
                v-else-if="healthdata.answers.medical.labs.general.blood_pressure.systolic <= 130 && healthdata.answers.medical.labs.general.blood_pressure.diastolic <= 80"
                class="text-yellow-dark"
              >Elevated ({{ healthdata.answers.medical.labs.general.blood_pressure.systolic }}/{{ healthdata.answers.medical.labs.general.blood_pressure.diastolic }})</span>
              <span
                v-else-if="healthdata.answers.medical.labs.general.blood_pressure.systolic <= 140 && healthdata.answers.medical.labs.general.blood_pressure.diastolic <= 90"
                class="text-red"
              >Stage I Hypertension ({{ healthdata.answers.medical.labs.general.blood_pressure.systolic }}/{{ healthdata.answers.medical.labs.general.blood_pressure.diastolic }})</span>
              <span
                v-else-if="healthdata.answers.medical.labs.general.blood_pressure.systolic > 140 || healthdata.answers.medical.labs.general.blood_pressure.diastolic > 90"
                class="text-red"
              >Stage II Hypertension ({{ healthdata.answers.medical.labs.general.blood_pressure.systolic }}/{{ healthdata.answers.medical.labs.general.blood_pressure.diastolic }})</span>
              <span
                v-else
                class="text-secondary"
              >Unknown</span>
            </li>
          </ul>
          <div class="card-body text-right">
            <div class="row">
              <div class="col-12 text-center">
                <h5>Reason for joining:</h5>
              </div>
              <div class="col-12 text-center">
                <span
                  v-if="healthdata.answers.general.why_fff.reason == 'healthier'"
                  class="font-italic"
                >"I want to learn how to make Healthier choices."</span>
                <span
                  v-if="healthdata.answers.general.why_fff.reason == 'sodium'"
                  class="font-italic"
                >"I want to decrease my Sodium intake."</span>
                <span
                  v-if="healthdata.answers.general.why_fff.reason == 'sugar'"
                  class="font-italic"
                >"I want to decrease my Sugar intake."</span>
                <span
                  v-if="healthdata.answers.general.why_fff.reason == 'carb'"
                  class="font-italic"
                >"I want to decrease my Carbohydrate Intake. (Count Carbs)"</span>
                <span
                  v-if="healthdata.answers.general.why_fff.reason == 'fiber'"
                  class="font-italic"
                >"I want to increase my Fiber intake."</span>
                <span
                  v-if="healthdata.answers.general.why_fff.reason == 'renal-nutrition'"
                  class="font-italic"
                >"I want to learn more about Renal nutrition."</span>
                <span
                  v-if="healthdata.answers.general.why_fff.reason == 'renal-diabetes-nutrition'"
                  class="font-italic"
                >"I want to learn more about both Renal Disease and Diabetes nutrition."</span>
                <span
                  v-if="healthdata.answers.general.why_fff.reason == 'diabetes'"
                  class="font-italic"
                >"I want to improve my Diabetes, Lose Weight, or Prevent Pre-Diabetes."</span>
                <span
                  v-if="healthdata.answers.general.why_fff.reason == 'other'"
                  class="font-italic"
                >"{{ healthdata.answers.general.why_fff.reason_desc }}"</span>
              </div>
            </div>
            <hr>
            <div class="row">
              <div class="col-12 text-center">
                <h5>Weight goals:</h5>
              </div>
              <div class="col-12 text-center font-italic">
                <p v-if="healthdata.answers.general.weight.goal == 'maintain'">
                  Maintain my current weight.
                </p>
                <p v-if="healthdata.answers.general.weight.goal == 'gain'">
                  Gain <strong>{{ healthdata.answers.general.weight.perweek }} lbs.</strong> per week to gain a total of <strong>{{ healthdata.answers.general.weight.target }} lbs</strong>.
                  <br>
                  You can achieve your goal in <strong>{{ healthdata.scorecard.weeks_to_weight_goal }} weeks</strong>!
                </p>
                <p v-if="healthdata.answers.general.weight.goal == 'lose'">
                  Lose <strong>{{ healthdata.answers.general.weight.perweek }} lbs.</strong> per week to lose a total of <strong>{{ healthdata.answers.general.weight.target }} lbs</strong>.
                  <br>
                  You can achieve your goal in <strong>{{ healthdata.scorecard.weeks_to_weight_goal }} weeks</strong>!
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-md-4">
        <div
          v-scroll="handleScroll"
          class="float-wrapper"
        >
          <div class="text-center mb-5 d-flex align-items-baseline">
            <router-link
              v-if="can('access-food-search')"
              :to="{name: 'my-favorites'}"
              class="text-white btn btn-success mb-3 flex-grow-1"
            >
              Food Search
            </router-link>
            <button
              v-else
              v-tooltip:top="'Requires Premium Plan'"
              class="text-white btn btn-success disabled mb-3 flex-grow-1"
            >
              Food Search
            </button>

            <i
              v-tooltip:top="'Food search with food groups, favorites, and a recipe maker to create recipes and access FFF recipes.'"
              class="text-primary fa fa-info-circle ml-1"
            />
          </div>

          <a
            href="https://www.foodfitnessfirstceu.com/shop"
            class="btn btn-block btn-warning"
            target="_blank"
          >
            <div class="store-link-text">Visit our online store HERE to purchase your FOOD SPIRAL® book and bifold.</div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return {
      bmiGaugeOpts: {
        staticLabels: {
          font: "10px sans-serif",
          labels: [0, 18, 25, 30, 35, 40, 50, 60],  // Print labels at these values
        },
        staticZones: [
          {strokeStyle: "rgba(198, 30, 36, 1)", min: 0, max: 18},  // Red
          {strokeStyle: "rgba(95, 159, 59, 1)", min: 19, max: 25}, // Green
          {strokeStyle: "rgba(154, 205, 114, 1)", min: 26, max: 30}, // Yellow
          {strokeStyle: "rgba(238, 197, 11, 1)", min: 31, max: 35}, // Yellow
          {strokeStyle: "rgba(198, 30, 36, 1)", min: 36, max: 40}, // Red
          {strokeStyle: "rgba(121, 0, 0, 1)", min: 41, max: 60}, // Dark Red
        ]
      },
      pulseGaugeOpts: {
        staticLabels: {
          font: "10px sans-serif",
          labels: [0,30,60,100,130,160],  // Print labels at these values
        },
        staticZones: [
          {strokeStyle: "rgba(198, 30, 36, 1)", min: 0, max: 30},  // Red
          {strokeStyle: "rgba(238, 197, 11, 1)", min: 31, max: 60}, // Yellow
          {strokeStyle: "rgba(95, 159, 59, 1)", min: 61, max: 100}, // Green
          {strokeStyle: "rgba(238, 197, 11, 1)", min: 101, max: 130}, // Yellow
          {strokeStyle: "rgba(198, 30, 36, 1)", min: 131, max: 160}, // Red
        ]
      },
      bodyFatGaugeOpts_male: {
        staticLabels: {
          font: "10px sans-serif",
          labels: [0, 20, 24, 31,40],  // Print labels at these values
        },
        staticZones: [
          {strokeStyle: "rgba(95, 159, 59, 1)", min: 0, max: 20}, // Green
          {strokeStyle: "rgba(154, 205, 114, 1)", min: 21, max: 24}, // Greenish
          {strokeStyle: "rgba(238, 197, 11, 1)", min: 25, max: 31}, // Yellow
          {strokeStyle: "rgba(198, 30, 36, 1)", min: 32, max: 40}, // Red
        ]
      },
      bodyFatGaugeOpts_female: {
        staticLabels: {
          font: "10px sans-serif",
          labels: [0, 13, 17, 24, 40],  // Print labels at these values
        },
        staticZones: [
          {strokeStyle: "rgba(95, 159, 59, 1)", min: 0, max: 13}, // Green
          {strokeStyle: "#8bff58", min: 14, max: 17}, // Greenish
          {strokeStyle: "#FFDD00", min: 18, max: 24}, // Yellow
          {strokeStyle: "rgba(198, 30, 36, 1)", min: 25, max: 40}, // Red
        ]
      }
    }
  },
  computed: {
    healthdata() {
      return this.$store.getters['healthData/current'];
    },
    hasBreakdownInformation() {
      return ! this.healthdata.answers.short_assessment;
    },
  },
  methods:{
    bmiStatus(value){
      if (value <  18.5)               return 'Underweight';
      if (value >= 18.5 && value < 25) return 'Normal';
      if (value >= 25   && value < 30) return 'Overweight';
      if (value >= 30   && value < 35) return 'Class I Obesity';
      if (value >= 35   && value < 40) return 'Class II Obesity';
      if (value >= 40)                 return 'Class III Obesity';
    },
    pulseStatus(value){
      return (value >= 60 && value < 100) ? 'Normal' : 'Abnormal';
    },
    bodyFatStatus(gender,value){
      if (gender === 'male'){
        if (value <= 20)                return 'Extremely Fit';
        if (value >  20 && value <= 24) return 'Fit';
        if (value >  24 && value <= 31) return 'Average';
        if (value >  31)                return 'Above Average';
      } else if (gender === 'female'){
        if (value <= 13)                return 'Extremely Fit';
        if (value >  13 && value <= 17) return 'Fit';
        if (value >  17 && value <= 24) return 'Average';
        if (value >  24)                return 'Above Average';
      }
    },
    gender(){
      if (this.healthdata.answers.general.gender === 'm') return 'male';
      if (this.healthdata.answers.general.gender === 'f') return 'female';
    },
    handleScroll(evt, el) {
      if (window.scrollY > 200 && window.innerWidth > 767) {
        el.classList.add('float')
      } else {
        el.classList.remove('float')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
    .individual-factor__wrapper {
        display:inline-block;
        line-height:0px;
        border-radius:50%;
        border:8px solid #609f3d;
        font-size:68px;
        background: #77a951;
        color: #f8f9fa;
    }

    .individual-factor__value {
        display:inline-block;
        padding-top:50%;
        padding-bottom:50%;
        margin-left:8px;
        margin-right:8px;
    }

    .card {
        margin-bottom: 20px;
    }

    .store-link-text {
        font-size: 1.5em;
    }

    .float-wrapper {

    }

    .float {
        position: fixed;
        top: 163px;
        margin-right: 20px;
        max-width: 344px;
    }
</style>
